define('MM/Components/Teams/Members/TeamMembers',['jquery'], function ($) {
    function TeamMembers(scope) {

    }

    return function init(args) {
        return args.IsExperienceEditorEditing ? null : new TeamMembers(args.scope);
    };
});
